import { query, request, requestWithoutError } from '@/utils/request';
import { stringify } from 'qs';

const prefix = '';
export async function getInstitutionTree(params) {
  return query(`${prefix}/api/zlbuser/institution/dept/tree`, {
    params,
  });
}

// 单位信息查询
export const reqCompanyInfo = () => {
  return query('/api/zlbuser/institution/departs');
};

// 报销类型
export async function reqReimburseType(params) {
  return request('/zlb/budget/dict/get-dict-by-type-code', { params });
}

// 单据打印生成接口
export async function reqPrintInfo(data) {
  return request('/zlb/api/expense/common/printInfo', {
    method: 'POST',
    data,
  });
}

// 前端页面资源鉴权查询
export async function pagePrivileges(params) {
  return request('/api/workbench/privileges/page_elements', {
    params,
  });
}

// 常用地查询
export const commonPlace = params => {
  return query(`/zlb/api/expense/apply-form/common-place?${stringify(params)}`);
};

// 资产更新计划打印
export async function reqAssetPrintInfo(params) {
  return request(`/zlb/budget/api/asset/apply-form/print-info/${params.formCode}`);
}

// 往来款打印
export async function reqIntercoursePrintInfo(params) {
  return request(`/zlb/api/financial/intercourse/common/print-info/${params.intercourseId}`);
}

// 报销类型
export async function printUserLog(data) {
  return requestWithoutError('/zlb/api/chaos/log/print', {
    method: 'POST',
    data,
  });
}

// 查询个人待确认完善的信息
export async function getUserMobile() {
  return query('/api/workbench/my/confirm_info/get');
}

// 通用接口-发送短信验证码
export async function getZlbUserNormalSmsCode(data) {
  return query('/api/zlbuser/normal/smsCode', {
    method: 'POST',
    data,
  });
}

// 通用接口-校验短信验证码
export async function checkZlbUserNormalSmsCode(data) {
  return query('/api/zlbuser/normal/smsCode/check', {
    method: 'POST',
    data,
  });
}
// 归档打印附件
export async function queryAttachmentList(data) {
  return request('/zlb/api/sop/paperless/print/attachment-list', {
    method: 'POST',
    data,
  });
}
// 退出登录
export function logoutRequest() {
  return query('/logout');
}

// 获取当前用户管理的部门
export const getOvertimeDepartList = data => {
  const { bizCode, ...rest } = data;
  return query(`/zlb/api/expense/common/queryManageDepartmentByBiz/${bizCode}`, {
    data: rest,
    method: 'GET',
  });
};
